// extracted by mini-css-extract-plugin
module.exports = {"CountHolder":"MenuLabel_CountHolder__1X7hF","SmallText":"MenuLabel_SmallText__2QDRe"};